// extracted by mini-css-extract-plugin
export default {"root":"detailPageCellRenderer_root__qsx0D","value":"detailPageCellRenderer_value__2vgGr","icon":"detailPageCellRenderer_icon__gMAb9"};